/* js/tracking.js */

;(function ($, window, document) {

    $(document).ready(function ($) {

        /**
         * Digital Brand Days Tracking
         */

        /**
         *
         * @type {jQuery|HTMLElement}
         * Tracking: Wie oft wurde ein Artikel gemerkt?
         * + welche Marke
         * + welche Artikelnummer
         */

        var _paq = window._paq = window._paq || [];

        var $target = $('.video-product .video-product--item .remember-article--trigger');

        $target.on('click', function () {

            var $item = $(this).parents().eq(1);

            if ($item.hasClass('is--remembered')) {

                var $brand = $item.attr('data-brand'),
                    $artNr = $item.attr('data-artnr');

                _paq.push(['trackEvent', 'DBD Artikel gemerkt (nach Marke)', $brand]);
                _paq.push(['trackEvent', 'DBD Artikel gemerkt (nach Artikelnummer)', $artNr]);

            }

        });

        /**
         *
         * @type {jQuery|HTMLElement}
         * Tracking: Wie oft wurde ein PDF generiert?
         */

        var $targetPdfLink = $('.remember-article--list-save a');

        $targetPdfLink.on('click', function () {

            _paq.push(['trackEvent', 'DBD PDF generiert', 'PDF erfolgreich generiert']);

        });


    });

})(jQuery, window, document);